module.exports = __webpack_public_path__ + "static/assets/97f7616dd4aac96ea35bab53a4b3642f.png";